"use client";

import { useState } from "react";

type Props = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  describedBy?: string;
  /** Maskierter Wert des gespeicherten Geheimnisses, nie der echte. */
  storedMask: string | null;
};

const control =
  "h-11 w-full min-w-0 rounded-md border border-field bg-white px-3 font-mono text-[13px] text-ink " +
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent";

export function SecretField({ id, label, value, onChange, placeholder, describedBy, storedMask }: Props) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="flex gap-2">
      <input
        id={id}
        type={visible ? "text" : "password"}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={storedMask ? `${storedMask} (gespeichert)` : placeholder}
        autoComplete="off"
        spellCheck={false}
        aria-describedby={describedBy}
        className={control}
      />
      <button
        type="button"
        onClick={() => setVisible((current) => !current)}
        aria-label={`${visible ? "Wert verbergen" : "Wert anzeigen"}: ${label}`}
        className="h-11 shrink-0 rounded-md border border-field bg-white px-3 text-[13px] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      >
        {visible ? "Verbergen" : "Anzeigen"}
      </button>
    </div>
  );
}
